<template>
  <el-cascader
    ref="refHandle"
    :class="[props.multiple ? 'multipleCus' : '']"
    v-model="cascaderValue"
    :options="listOptions"
    :placeholder="placeholder"
    clearable
    :show-all-levels="false"
    :props="props"
    :collapse-tags="true"
    @change="handleChange"
    @visible-change="handleChangeVisible"
  />
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "crmCascader",
  props: {
    value: {},
    options: Array,
    placeholder: String,
    props: {
      type: Object,
      normal: { checkStrictly: true },
    },
  },
  data() {
    return {
      visible: false,
      cascaderValue: null,
      listOptions: [],
    };
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (!this.props?.multiple) {
          if (this.$refs.refHandle) {
            const children = this.$refs.refHandle.getCheckedNodes();
            this.$refs.refHandle.dropDownVisible = false; // 监听值发生变化就关闭它
          }
        }
      },
    },
    options: {
      handler(newVal, oldVal) {
        if (newVal.length !== 0) {
          const loop = (item) => {
            item.forEach((v) => {
              if (v.value === this.userInfo.teamId) {
                this.listOptions.push(v);
              } else if (v.children) {
                loop(v.children);
              }
            });
          };
          loop(newVal);
        }
      },
    },
  },
  computed: {
    ...mapGetters({
      userInfo: "authority/userInfo",
    }),
  },
  created() {
    if (!this.props?.multiple) {
      this.cascaderValue = this.userInfo.teamId;
    } else {
      this.cascaderValue = [this.userInfo.teamId];
    }
  },
  methods: {
    handleFocus() {
      this.visible = true;
    },
    handleChange(e) {
      if (!this.props?.multiple) {
        this.$emit("change", e);
      } else {
        const multipleValue = [];
        this.cascaderValue.forEach((item) => {
          multipleValue.push(item[item.length - 1]);
        });
        this.$emit("change", {
          value: multipleValue,
          type: "multiple",
        });
      }
    },
    handleChangeVisible(value) {
      this.visible = value;
    },
  },
};
</script>
<style lang="less" scoped>
.multipleCus {
  /deep/ .el-input--suffix {
    width: 200px;
  }
  /deep/ .el-cascader__tags {
    flex-wrap: nowrap;
  }
}
</style>
